import { render, staticRenderFns } from "./CockpitMatryoshkaItemAuditList.vue?vue&type=template&id=254e398c&scoped=true"
import script from "./CockpitMatryoshkaItemAuditList.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemAuditList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254e398c",
  null
  
)

export default component.exports